module.exports = __webpack_public_path__ + "static/media/aeps.e5ecf26c.png";